import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "exclamation--circle",
  "use": "exclamation--circle-usage",
  "viewBox": "0 0 18.763 18.77",
  "content": "<symbol viewBox=\"0 0 18.763 18.77\" id=\"exclamation--circle\"><path d=\"M9.375 0a9.36 9.36 0 0 0-6.637 2.736c-3.651 3.645-3.651 9.614 0 13.261a9.276 9.276 0 0 0 6.625 2.773c2.4 0 4.799-.924 6.65-2.748a9.31 9.31 0 0 0 2.75-6.643A9.364 9.364 0 0 0 9.375 0zm5.212 14.598a7.369 7.369 0 0 1-5.224 2.154 7.37 7.37 0 0 1-5.225-2.154c-2.875-2.871-2.875-7.567 0-10.439 2.875-2.873 7.574-2.873 10.449 0a7.325 7.325 0 0 1 2.175 5.22 7.322 7.322 0 0 1-2.175 5.219zM8 10.787h3v3.001H8v-3.001zm0-5.999h3v4.5H8v-4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/exclamation--circle.svg
// module id = 160
// module chunks = 0